import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const TimeAgo = ({ pastDate }: { pastDate: number }) => {
  const { t } = useTranslation();
  const [timeAgo, setTimeAgo] = useState("");

  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date();
      const past = new Date(pastDate);
      const ms = now.getTime() - past.getTime();
      const seconds = Math.floor((ms / 1000) % 60);
      const minutes = Math.floor((ms / 1000 / 60) % 60);
      const hours = Math.floor((ms / (1000 * 60 * 60)) % 24);
      const days = Math.floor((ms / (1000 * 60 * 60 * 24)) % 30);
      const months = Math.floor((ms / (1000 * 60 * 60 * 24 * 30)) % 12);
      const years = Math.floor(ms / (1000 * 60 * 60 * 24 * 365));

      setTimeAgo(`
        ${years !== 0 ? years + `${t("y")} ` : ""}
        ${months !== 0 ? months + `${t("m")} ` : ""}
        ${days !== 0 ? days + `${t("d")} ` : ""}
        ${hours !== 0 ? hours + `${t("h")} ` : ""}
        ${minutes !== 0 ? minutes + `${t("m")} ` : ""}
        ${seconds} ${t("s ago")}
      `);
    }, 1000);

    return () => clearInterval(timer);
  }, [pastDate, t]);

  return <div>{timeAgo}</div>;
};

export default TimeAgo;
